export const CARD_FIELDS = [
    {
        key: 'card.product.imageRadius',
        group: '상품 카드',
        label: '이미지 모서리 둥글기',
        help: '마켓·홈·프로필 상점 등의 상품 카드(세로형·가로형) 상품 이미지의 모서리 둥글기',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.s-plus',
        min: 0,
        max: 40,
    },
    {
        key: 'card.product.textGap',
        group: '상품 카드',
        label: '이미지·글자 간격',
        help: '세로형 상품 카드(이미지 아래에 이름·가격)에서 이미지와 이름, 이름과 가격 사이 간격',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 32,
    },
    {
        key: 'card.product.nameLines',
        group: '상품 카드',
        label: '상품 이름 최대 줄 수',
        help: '상품 카드에서 상품 이름을 몇 줄까지 보일지. 넘치면 끝이 …으로 줄어든다',
        type: 'integer',
        defaultValue: 2,
        min: 1,
        max: 3,
        unit: '줄',
    },
    {
        key: 'card.broadcast.imageRadius',
        group: '방송 카드',
        label: '썸네일 모서리 둥글기',
        help: '홈·라이브 더보기·프로필의 진행중/예정 라이브 카드 썸네일의 모서리 둥글기',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.s-plus',
        min: 0,
        max: 40,
    },
    {
        key: 'card.broadcast.textGap',
        group: '방송 카드',
        label: '썸네일·글자 간격',
        help: '라이브 카드에서 썸네일과 방송 제목, 제목과 카테고리 배지 사이 간격',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 32,
    },
    {
        key: 'card.broadcast.titleLines',
        group: '방송 카드',
        label: '방송 제목 최대 줄 수',
        help: '라이브 카드에서 방송 제목을 몇 줄까지 보일지. 넘치면 끝이 …으로 줄어든다',
        type: 'integer',
        defaultValue: 2,
        min: 1,
        max: 3,
        unit: '줄',
    },
    {
        key: 'card.post.paddingY',
        group: '라운지 글',
        label: '위아래 안쪽 여백',
        help: '라운지 글 목록·인기글·내가 쓴 글의 글 한 줄(PostPreviewCard) 위아래 여백 — 글 사이 간격이 이만큼 바뀐다',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.l',
        min: 0,
        max: 40,
    },
    {
        key: 'card.post.thumbnailRadius',
        group: '라운지 글',
        label: '썸네일 모서리 둥글기',
        help: '라운지 글 오른쪽 사진 썸네일의 모서리 둥글기',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.s',
        min: 0,
        max: 40,
    },
    {
        key: 'card.post.titleLines',
        group: '라운지 글',
        label: '글 제목 최대 줄 수',
        help: '라운지 글 제목을 몇 줄까지 보일지. 넘치면 끝이 …으로 줄어든다',
        type: 'integer',
        defaultValue: 2,
        min: 1,
        max: 3,
        unit: '줄',
    },
    {
        key: 'card.post.dividerVisible',
        group: '라운지 글',
        label: '글 사이 구분선',
        help: '라운지 글 한 줄 아래의 가는 구분선을 보인다. 끄면 여백만으로 글을 나눈다',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=card.js.map